import { render } from "./TheMbBottom.vue?vue&type=template&id=9b6deb4a&scoped=true"
import script from "./TheMbBottom.vue?vue&type=script&lang=js"
export * from "./TheMbBottom.vue?vue&type=script&lang=js"

import "./TheMbBottom.vue?vue&type=style&index=0&id=9b6deb4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b6deb4a"

export default script